module.exports = __webpack_public_path__ + "media/images/coin-icon-cc06bbfa25c7dfe51a2fdd44abe095fd.svg";